import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom'
import '../../styles/pages/Admin/Dashboard.scss';
import SERVER from '../../hooks/useServer';
import axios from 'axios';
import useAuth from '../../hooks/useAuth';
import NavbarAdmin from '../../components/NavbarAdmin';
import AdminCommandes from '../../components/Admin/Commandes';
import AdminProducts from '../../components/Admin/AdminProducts';
import AdminSubCategories from '../../components/Admin/AdminSubcategories';
import AdminCategories from '../../components/Admin/AdminCategories';
import Admins from '../../components/Admin/Admins';
import AdminShipping from '../../components/Admin/AdminShipping';

const Dashboard = () => {
    // State declarations
    const { user, userLoading } = useAuth();
    const [loading, setLoading] = useState(null)
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [products, setProducts] = useState([]);
    const [commandes, setCommandes] = useState([])
    const [admins, setAdmins] = useState([])
    const [shippingFees, setShippingFees] = useState([]);
    const [activeTab, setActiveTab] = useState('categories');
    const [error, setError] = useState(null);

    // Fetch data on component mount
    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                await Promise.all([
                    fetchCategories(),
                    fetchSubCategories(),
                    fetchProducts(),
                    fetchCommandes(),
                    fetchAdmins(),
                    fetchShippingFees()
                ]);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        if(user){
            fetchData();
        }
    }, [user]);

    // API functions
    const fetchCategories = async () => {
        try {
            const response = await axios.get(`${SERVER}/categories`);
            setCategories(response.data);
        } catch (err) {
            throw new Error(`Erreur lors de la récupération des catégories: ${err.message}`);
        }
    };

    const fetchSubCategories = async () => {
        try {
            const response = await axios.get(`${SERVER}/subcategories`);
            setSubCategories(response.data);
        } catch (err) {
            throw new Error(`Erreur lors de la récupération des sous-catégories: ${err.message}`);
        }
    };

    const fetchProducts = async () => {
        try {
            const response = await axios.get(`${SERVER}/products`);
            setProducts(response.data);
        } catch (err) {
            throw new Error(`Erreur lors de la récupération des produits: ${err.message}`);
        }
    };

    const fetchCommandes = async () => {
        try {
            const response = await axios.get(`${SERVER}/commandes`);
            setCommandes(response.data);
        } catch (err) {
            throw new Error(`Erreur lors de la récupération des commandes: ${err.message}`);
        }
    };

    const fetchAdmins = async () => {
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(`${SERVER}/auth/admins`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });
            setAdmins(response.data);
        } catch (err) {
            throw new Error(`Erreur lors de la récupération des admins: ${err.message}`);
        }
    };

    const fetchShippingFees = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${SERVER}/shipping`);
            console.log(response.data)
            setShippingFees(response.data);
        } catch (err) {
            setError(err.response?.data?.error || err.message);
        } finally {
            setLoading(false);
        }
    };


    if (loading) return <div className="loading">Chargement...</div>;
    if (error) return <div className="error">Erreur: {error}</div>;
    if (userLoading) {
        return <div className="loading">Chargement...</div>
    }
    else if (!user) {
        return <Navigate to="/admin/login" />;
    }else{
       return (
            <div className='admin'>
                <NavbarAdmin />
                <h1>Tableau de bord Admin</h1>

                {/* Tabs */}
                <div className="admin-tabs">
                    <button 
                        className={activeTab === 'categories' ? 'active' : ''} 
                        onClick={() => { setActiveTab('categories'); }}
                    >
                        Catégories
                    </button>
                    <button 
                        className={activeTab === 'subCategories' ? 'active' : ''} 
                        onClick={() => { setActiveTab('subCategories'); }}
                    >
                        Sous-catégories
                    </button>
                    <button 
                        className={activeTab === 'products' ? 'active' : ''} 
                        onClick={() => { setActiveTab('products'); }}
                    >
                        Produits
                    </button>
                    <button 
                        className={activeTab === 'commandes' ? 'active' : ''} 
                        onClick={() => { setActiveTab('commandes'); }}
                    >
                        Commandes
                    </button>
                    <button 
                        className={activeTab === 'admins' ? 'active' : ''} 
                        onClick={() => { setActiveTab('admins'); }}
                    >
                        Admins
                    </button>
                    <button 
                        className={activeTab === 'shipping' ? 'active' : ''} 
                        onClick={() => { setActiveTab('shipping'); }}
                    >
                        Frais de transport
                    </button>
                    
                </div>

                {/* Categories Tab */}
                {activeTab === 'categories' && (
                    <AdminCategories activeTab={activeTab} categories={categories} setCategories={setCategories} />
                )}

                {/* SubCategories Tab */}
                {activeTab === 'subCategories' && (
                    <AdminSubCategories activeTab={activeTab} subCategories={subCategories} setSubCategories={setSubCategories} categories={categories} />
                )}

                {/* Products Tab */}
                {activeTab === 'products' && (
                    <AdminProducts activeTab={activeTab} products={products} setProducts={setProducts} categories={categories} subCategories={subCategories} />
                )}

                {activeTab === 'commandes' && (
                    <AdminCommandes activeTab={activeTab} commandes={commandes} setCommandes={setCommandes} />
                )}
                {activeTab === 'admins' && (
                    <Admins activeTab={activeTab} admins={admins} setAdmins={setAdmins} />
                )}
                {activeTab === 'shipping' && (
                    <AdminShipping activeTab={activeTab} shippingFees={shippingFees} setShippingFees={setShippingFees} />
                )}
            </div>
        );
    }
};

export default Dashboard;